import axios from 'axios';
import { getApiUrl } from '../../../config';

export function requestAddComment(type, id, data) {
    return axios.request({
        method: "post",
        url: getApiUrl() + '/comment/' + type + "/" + id,
        data: data,
        withCredentials: true,
        crossorigin: true
    });
}

export function requestEditComment(type, id, commentId, data) {
    return axios.request({
        method: "put",
        url: getApiUrl() + '/comment/' + type + "/" + id + "/" + commentId,
        data: data,
        withCredentials: true,
        crossorigin: true
    });
}

export function requestDeleteComment(type, id, commentId) {
    return axios.request({
        method: "delete",
        url: getApiUrl() + '/comment/' + type + "/" + id + "/" + commentId,
        withCredentials: true,
        crossorigin: true
    });
}

export function requestRestoreComment(type, id, commentId) {
    return axios.request({
        method: "put",
        url: getApiUrl() + '/comment/' + type + "/" + id + "/" + commentId + "/restore",
        withCredentials: true,
        crossorigin: true
    });
}
